function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.98278 3.24609H0.954102V13.9998H1.98278V3.24609Z",
  fill: "#DDDDDD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5746 3.24609H9.5459V13.9998H10.5746V3.24609Z",
  fill: "#DDDDDD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.78063 4.45459H6.75195V11.7986H7.78063V4.45459Z",
  fill: "#DDDDDD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.77672 4.45459H3.74805V11.7986H4.77672V4.45459Z",
  fill: "#DDDDDD"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.75554 0H4.77637V2.15848H6.75554V0Z",
  fill: "#DDDDDD"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5732 13.9983V12.9233L0.95717 12.9233V13.9983L10.5732 13.9983Z",
  fill: "#DDDDDD"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5303 2.15892V1.08398L0.000862122 1.08398V2.15892L11.5303 2.15892Z",
  fill: "#DDDDDD"
});

var SvgOrgDelete = function SvgOrgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/org-delete.501146bf.svg";
export { ForwardRef as ReactComponent };